import { createReducerContext } from '../../../../utils/create-reducer-context';
import { PurchaseContractSearchState, PurchaseContractSearchReducer, ACTION_TYPES } from './purchase-contract-search-reducer';

const initialState: PurchaseContractSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    documentTypes: [],
    drawer: { open: false, files: [] },
};

const { Provider: PurchaseContractSearchProvider, useStateContext: usePurchaseContractSearchState, useDispatchContext: usePurchaseContractSearchDispatch } = createReducerContext('PurchaseContractSearch', PurchaseContractSearchReducer, initialState);

export { PurchaseContractSearchProvider, usePurchaseContractSearchState, usePurchaseContractSearchDispatch, ACTION_TYPES };
